import { SupabaseLoadNotificationPreferencesRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadNotificationPreferences } from '@/shared/domain'

export function makeLoadNotificationPreferences(): LoadNotificationPreferences {
  return new SupabaseLoadNotificationPreferencesRepository(makeSupabaseEdgeHttpClient()).execute
}
